export const deviceProfileTypes = {
    UPDATE_ATTR_SCHEDULE: "DEVICE_PROFILE_UPDATE_ATTR_SCHEDULE",
    FETCH_REQUEST: "DEVICE_PROFILE_FETCH_REQUEST",
    FETCH_SUCCESS: "DEVICE_PROFILE_FETCH_SUCCESS",
    FETCH_ALL_ASSET_REQUEST: "ALL_ASSET_FETCH_REQUEST",
    FETCH_ALL_ASSET_SUCCESS: "ALL_ASSET_FETCH_SUCCESS",
    FETCH_ALL_ASSET_FAILURE: "ALL_ASSET_FETCH_FAILURE",
    FETCH_ALL_LOCATION_REQUEST: "ALL_LOCATION_FETCH_REQUEST",
    FETCH_ALL_LOCATION_SUCCESS: "ALL_LOCATION_FETCH_SUCCESS",
    FETCH_ALL_LOCATION_FAILURE: "ALL_LOCATION_FETCH_FAILURE",
    UPDATE_FILTERS: "DEVICE_PROFILE_UPDATE_FILTERS",
    FETCH_FAILURE: "DEVICE_PROFILE_FETCH_FAILURE",
    UPDATE_UI: "DEVICE_PROFILE_UPDATE_UI",
    UPDATE_PAGINATION_REQUEST: "DEVICE_PROFILE_UPDATE_PAGINATION_REQUEST",
    DELETE_REQUEST: "DEVICE_PROFILE_DELETE_REQUEST",
    DELETE_SUCCESS: "DEVICE_PROFILE_DELETE_SUCCESS",
    DELETE_FAILURE: "DEVICE_PROFILE_DELETE_FAILURE",
    CREATE_REQUEST: "DEVICE_PROFILE_CREATE_REQUEST",
    CREATE_SUCCESS: "DEVICE_PROFILE_CREATE_SUCCESS",
    CREATE_FAILURE: "DEVICE_PROFILE_CREATE_FAILURE",
    FETCH_DEVICETYPE_REQUEST: "DEVICE_PROFILE_FETCH_DEVICETYPE_REQUEST",
    FETCH_DEVICETYPE_SUCCESS: "DEVICE_PROFILE_FETCH_DEVICETYPE_SUCCESS",
    FETCH_DEVICETYPE_FAILURE: "DEVICE_PROFILE_FETCH_DEVICETYPE_FAILURE",
    UPDATE_REQUEST: "DEVICE_PROFILE_UPDATE_REQUEST",
    UPDATE_SUCCESS: "DEVICE_PROFILE_UPDATE_SUCCESS",
    UPDATE_FAILURE: "DEVICE_PROFILE_UPDATE_FAILURE",
    DOWNLOAD_REQUEST: "DEVICE_PROFILE_DOWNLOAD_REQUEST",
    DOWNLOAD_SUCCESS: "DEVICE_PROFILE_DOWNLOAD_SUCCESS",
    DOWNLOAD_FAILURE: "DEVICE_PROFILE_DOWNLOAD_FAILURE",
    SHIPMENT_VALIDATION_REQUEST: "DEVICE_PROFILE_SHIPMENT_VALIDATION_REQUEST",
    SHIPMENT_VALIDATION_SUCCESS: "DEVICE_PROFILE_SHIPMENT_VALIDATION_SUCCESS",
    SHIPMENT_VALIDATION_FAILURE: "DEVICE_PROFILE_SHIPMENT_VALIDATION_FAILURE",
};

export const fetchRequest = (filter) => ({
    type: deviceProfileTypes.FETCH_REQUEST,
    payload: filter
});

export const fetchSuccess = (resp) => ({
    type: deviceProfileTypes.FETCH_SUCCESS,
    payload: resp
});
export const fetchallAssetRequest = (id) => ({
    type: deviceProfileTypes.FETCH_ALL_ASSET_REQUEST,
    payload: id
});

export const fetchallAssetSuccess = (resp) => ({
    type: deviceProfileTypes.FETCH_ALL_ASSET_SUCCESS,
    payload: resp
});

export const fetchallAssetFailure = (resp) => ({
    type: deviceProfileTypes.FETCH_ALL_ASSET_FAILURE,
    payload: resp
});
export const fetchalllocationRequest = (id) => ({
    type: deviceProfileTypes.FETCH_ALL_LOCATION_REQUEST,
    payload: id
});

export const fetchalllocationSuccess = (resp) => ({
    type: deviceProfileTypes.FETCH_ALL_LOCATION_SUCCESS,
    payload: resp
});

export const fetchalllocationFailure = (resp) => ({
    type: deviceProfileTypes.FETCH_ALL_LOCATION_FAILURE,
    payload: resp
});
export const updateFilters = (resp) => ({
    type: deviceProfileTypes.UPDATE_FILTERS,
    payload: resp
});

export const fetchFailure = (resp) => ({
    type: deviceProfileTypes.FETCH_FAILURE,
    payload: resp
});

export const updateUI = (req) => ({
    type: deviceProfileTypes.UPDATE_UI,
    payload: req
});

export const updatePaginationRequest = (req) => ({
    type: deviceProfileTypes.UPDATE_PAGINATION_REQUEST,
    payload: req
});

export const deleteRequest = () => ({
    type: deviceProfileTypes.DELETE_REQUEST,
});

export const deleteSuccess = (resp) => ({
    type: deviceProfileTypes.DELETE_SUCCESS,
    payload: resp
});

export const deleteFailure = (resp) => ({
    type: deviceProfileTypes.DELETE_FAILURE,
    payload: resp
});

export const createRequest = () => ({
    type: deviceProfileTypes.CREATE_REQUEST,
});

export const createSuccess = (resp) => ({
    type: deviceProfileTypes.CREATE_SUCCESS,
    payload: resp
});

export const createFailure = (resp) => ({
    type: deviceProfileTypes.CREATE_FAILURE,
    payload: resp
});

export const fetchDeviceTypeRequest = () => ({
    type: deviceProfileTypes.FETCH_DEVICETYPE_REQUEST,
});

export const fetchDeviceTypeSuccess = (resp) => ({
    type: deviceProfileTypes.FETCH_DEVICETYPE_SUCCESS,
    payload: resp
});

export const fetchDeviceTypeFailure = (resp) => ({
    type: deviceProfileTypes.FETCH_DEVICETYPE_FAILURE,
    payload: resp
});

export const updateRequest = () => ({
    type: deviceProfileTypes.UPDATE_REQUEST,
});

export const updateSuccess = (resp) => ({
    type: deviceProfileTypes.UPDATE_SUCCESS,
    payload: resp
});

export const updateFailure = (resp) => ({
    type: deviceProfileTypes.UPDATE_FAILURE,
    payload: resp
});

export const downloadRequest = (total, filters) => ({
    type: deviceProfileTypes.DOWNLOAD_REQUEST,
    payload: total,
    filter: filters
});

export const downloadSuccess = (resp) => ({
    type: deviceProfileTypes.DOWNLOAD_SUCCESS,
    payload: resp
});

export const downloadFailure = (error) => ({
    type: deviceProfileTypes.DOWNLOAD_FAILURE,
    payload: error
});
export const shipmentValidationRequest = (resp) => ({
    type: deviceProfileTypes.SHIPMENT_VALIDATION_REQUEST,
    payload:resp
});

export const shipmentValidationSuccess = (resp) => ({
    type: deviceProfileTypes.SHIPMENT_VALIDATION_SUCCESS,
    payload: resp
});

export const shipmentValidationFailure = (resp) => ({
    type: deviceProfileTypes.SHIPMENT_VALIDATION_FAILURE,
    payload: resp
});

export const updateAttrSchedule = (attrKey, schedule) => ({
    type: deviceProfileTypes.UPDATE_ATTR_SCHEDULE,
    payload: { attrKey, schedule },
});